import logo from 'assets/images/logo.svg'
import ydoLogo from 'assets/images/logo_white.png'
import profile from 'assets/images/profile.png'
// import profileicon from 'assets/images/icon_1.png'
import male from 'assets/images/male_4.png'
import iconMenue from 'assets/images/icon_menu.png'
import labrequicon from 'assets/images/labrequicon.svg'
import consultImage from 'assets/images/revision.png'
import pastConsult from 'assets/images/bg1.png'
import bg1 from 'assets/images/bg1.png'
import bg5 from 'assets/images/bg5.svg'
import pastConsulting from 'assets/images/Vector.svg'
import pastConsultationIcon from 'assets/images/Group.svg'
import backbutton from 'assets/images/icon_back@2x.png'
import pic from 'assets/images/defalt_user@2x.png'
import forwardIcon from 'assets/images/Icon ionic-ios-arrow-forward.png'
import chatIcon from 'assets/images/chat-bubbles-with-ellipsis@2x.png'
import chatInactiveIcon from 'assets/images/chat-bubbles-with-ellipsis@2x.png'
import phoneIcon from 'assets/images/Icon awesome-phone@2x.png'
import videoIcon from 'assets/images/Icon awesome-video@2x.png'
import sickNote from 'assets/images/sidebar_sicknotes.svg'
import bg2 from 'assets/images/bg2.svg'
import bg3 from 'assets/images/bg3.svg'
import cross from 'assets/images/cross-symbol-icon-button-png.webp'
import sign from 'assets/images/draw_signature.png'
import attachment from 'assets/images/attahcment.png'
import send from 'assets/images/ic (1).svg'
import dot from 'assets/images/threedot.png'
import pending from 'assets/images/pending.svg'
import past from 'assets/images/past.svg'
import pasbBack from 'assets/images/bg1 (3).svg'
import icon from 'assets/images/icon_1.svg'
import disableChat from 'assets/images/chat-bubbles-with-ellipsis.svg'

export const images = {
  logo,
  profile,
  ydoLogo,
  // profileicon,
  male,
  iconMenue,
  consultImage,
  pastConsult,
  pastConsulting,
  backbutton,
  pic,
  bg1,
  forwardIcon,
  chatIcon,
  chatInactiveIcon,
  phoneIcon,
  videoIcon,
  sickNote,
  bg2,
  cross,
  bg3,
  attachment,
  sign,
  send,
  dot,
  pending,
  past,
  pasbBack,
  icon,
  disableChat,
  pastConsultationIcon,
  bg5,
  labrequicon,
}

export default {}
